var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-search" }, [
    _c("form", [
      _c("div", { staticClass: "row row-clear-sm-6-md-4" }, [
        _c("div", { staticClass: "col-sm-6 col-md-4" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "sr-only" }, [_vm._v("Keywords")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.stateKeywords,
                  expression: "stateKeywords",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: "keywords",
                type: "text",
                placeholder: "Keywords",
              },
              domProps: { value: _vm.stateKeywords },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.stateKeywords = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { staticClass: "sr-only" }, [_vm._v("Request Type")]),
              _vm._v(" "),
              _c("selectize", {
                ref: "opportunity",
                staticClass: "selectize selectize-multiple",
                attrs: {
                  multiple: "",
                  name: "opportunity",
                  placeholder: "Request Type",
                  options: _vm.opportunityOptions,
                },
                model: {
                  value: _vm.stateOpportunities,
                  callback: function ($$v) {
                    _vm.stateOpportunities = $$v
                  },
                  expression: "stateOpportunities",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 col-md-4" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "sr-only" }, [_vm._v("Due")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("flatpickr", {
                  staticClass: "form-control",
                  attrs: {
                    config: _vm.flatPickerDateConfig,
                    placeholder: "Date",
                    name: "date_range",
                  },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.$costReferences
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "sr-only" }, [_vm._v("Amount")]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.stateAmountLow,
                          expression: "stateAmountLow",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "amount_low",
                        type: "text",
                        placeholder: "Amount Low",
                      },
                      domProps: { value: _vm.stateAmountLow },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.stateAmountLow = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.stateAmountHigh,
                          expression: "stateAmountHigh",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "amount_high",
                        type: "text",
                        placeholder: "Amount High",
                      },
                      domProps: { value: _vm.stateAmountHigh },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.stateAmountHigh = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { staticClass: "sr-only" }, [_vm._v("Location")]),
              _vm._v(" "),
              _c("selectize", {
                ref: "locations",
                staticClass: "selectize selectize-multiple",
                attrs: {
                  multiple: "",
                  name: "location",
                  placeholder: "Location",
                  options: _vm.locationOptions,
                },
                model: {
                  value: _vm.stateLocations,
                  callback: function ($$v) {
                    _vm.stateLocations = $$v
                  },
                  expression: "stateLocations",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [_vm._v("Region")]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "regions",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "region",
                      placeholder: "Region",
                      options: _vm.regionOptions,
                    },
                    model: {
                      value: _vm.stateRegions,
                      callback: function ($$v) {
                        _vm.stateRegions = $$v
                      },
                      expression: "stateRegions",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsManager
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v(
                      _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "talent",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "talent",
                      placeholder: _vm.$options.filters.sentenceCase(
                        _vm.$starLabelPlural
                      ),
                      options: _vm.talentOptions,
                      "pre-load": true,
                      "fetch-results": _vm.fetchTalentCallback,
                      "fetch-more-results": _vm.fetchMoreTalentCallback,
                    },
                    model: {
                      value: _vm.stateTalent,
                      callback: function ($$v) {
                        _vm.stateTalent = $$v
                      },
                      expression: "stateTalent",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsClient || _vm.$userIsAdmin || _vm.$userIsManager
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "sr-only" }, [
                  _vm._v("Request Number"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.stateId,
                      expression: "stateId",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "id",
                    type: "text",
                    placeholder: "Request Number",
                  },
                  domProps: { value: _vm.stateId },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.stateId = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin
          ? _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v("Assigned Admin"),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "assignedAdmin",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "assignedAdmin",
                      placeholder: "Assigned Admin",
                      options: _vm.adminUsers,
                    },
                    model: {
                      value: _vm.stateAssignedAdmin,
                      callback: function ($$v) {
                        _vm.stateAssignedAdmin = $$v
                      },
                      expression: "stateAssignedAdmin",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin
          ? _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("organisation"))),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "client",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "client",
                      placeholder: _vm.$options.filters.sentenceCase(
                        _vm.$t("organisation")
                      ),
                      options: _vm.clientUsers,
                      "pre-load": true,
                      "fetch-results": _vm.fetchClientsCallback,
                      "fetch-more-results": _vm.fetchNextClientsCallback,
                    },
                    model: {
                      value: _vm.stateClient,
                      callback: function ($$v) {
                        _vm.stateClient = $$v
                      },
                      expression: "stateClient",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin && !_vm.$vlastMode
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v("Pipeline Status"),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "pipeline_status",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "pipeline_status",
                      placeholder: "Pipeline Status",
                      options: _vm.pipelineStatusOptions,
                    },
                    model: {
                      value: _vm.statePipelineStatus,
                      callback: function ($$v) {
                        _vm.statePipelineStatus = $$v
                      },
                      expression: "statePipelineStatus",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin && _vm.$vlastMode
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v("Requested Department"),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "requested_department",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "requested_department",
                      placeholder: "Department",
                      options: _vm.requestedDepartmentOptions,
                      "fetch-results": _vm.getDepartments,
                      "fetch-more-results": _vm.getNextDepartments,
                    },
                    model: {
                      value: _vm.stateRequestedDepartment,
                      callback: function ($$v) {
                        _vm.stateRequestedDepartment = $$v
                      },
                      expression: "stateRequestedDepartment",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-right",
            class: {
              "col-sm-12":
                _vm.$userIsManager || _vm.$userIsClient || _vm.$userIsAdmin,
              "col-sm-6 col-md-4": _vm.$userIsTalent,
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { on: { click: _vm.trackFilterApply } },
                [_vm._t("button")],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-toggle": "" } },
      [_c("i", { staticClass: "fa fa-calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-clear": "" } },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }